import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import star from '../../../../assets/images/backgrounds/star.svg';
import arrowRight from '../../../../assets/images/icons/arrow/chevron-right-black.svg';

export const useStyles = makeStyles(({
  fontWeights,
  palette,
  breakpoints,
  borderRadiuses,
}: Theme) => ({
  root: {
    position: 'relative',
    padding: '32px 32px 32px 0',
  },
  arrowRight: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '2rem',
    height: '2rem',
    background: `no-repeat url(${arrowRight}) center center`,
    backgroundSize: '0.625rem 1.25rem',
  },
  title: {
    marginTop: 0,
    marginBottom: '0.75rem',
    color: palette.text.primary,
    fontSize: '1rem',
    lineHeight: 1.5,
    fontWeight: fontWeights.medium,
  },
  content: {
    [breakpoints.up('sm')]: {
      display: 'flex',
    },
    [breakpoints.up('xl')]: {
      flexDirection: 'column',
    },
  },
  ratingWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: '0 0 8px',
  },
  rating: {
    paddingLeft: 20,
    backgroundImage: `url(${star})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px 16px',
    backgroundPosition: 'left top 2px',
  },
  pointSeparator: {
    position: 'relative',
    paddingRight: 10,
    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      right: 3,
      top: '50%',
      transform: 'translateY(-50%)',
      height: 2,
      width: 2,
      borderRadius: borderRadiuses.xxl,
      background: palette.text.primary,
    },
  },
  street: {
    margin: '0 0 0.25rem',
  },
  phone: {
    margin: 0,
    color: palette.primary.dark,
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus': {
      outline: '1px dotted',
      outlineColor: palette.primary.dark,
    },
  },
  hours: {
    margin: '0 0 0.25rem',
  },
  iconWrapper: {
    position: 'relative',
    paddingLeft: '2rem',
    [breakpoints.up('sm')]: {
      paddingLeft: '1.5rem',
    },
  },
  icon: {
    position: 'absolute',
    left: 0,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '1.25rem',
    [breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
      width: '1.5rem',
    },
  },
}));
